<template>
    <div class="condition-content">
        <region-selector
            ref="locationSelect"
            :value="currentValue"
            class="data-filter-trigger"
            :class="{ changeWidth: citiesLength > 0 }"
            :inline="false"
            :polymerization="true"
            :immediate-render="true"
            @input="onChange"
            @getCity="handleChangeValue"
            @startRenderComplete="handleRenderComplete"
        >
            <template slot="header">
                <span
                    v-if="!citiesLength"
                    :class="{ 'region-nodata': true, 'trigger-invalid': !valid }"
                >{{
                    placeholder
                }}</span>
                <div
                    v-else
                    ref="wait"
                    class="region-label"
                >
                    <!-- {{ firstCityStr }} -->
                    {{ allCity }}
                    <span v-if="showWait">等</span>
                </div>
            </template>
        </region-selector>
    </div>
</template>

<script>
import RegionSelector from '@/components/region-selector';
import substring from '@/utils/substring';
import { isArray } from '@/utils/types';
import { getRegionText } from '../utils';

export default {
  name: 'Region',

  components: {
    RegionSelector,
  },

  props: {
    value: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    // 当前组件在菜单中的配置
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    let currentValue = [];
    if (isArray(this.value)) {
      currentValue = this.value;
    } else if (this.value && isArray(this.value.value)) {
      currentValue = this.value.value;
    }
    return {
      currentValue,
      firstCity: '',
      citiesLength: 0,
      allCity: '',
      showWait: false,
      valid: true,
    };
  },

  computed: {
    firstCityStr() {
      return this.citiesLength > 1
        ? `${this.formatLabel(this.firstCity, 12)}等${this.citiesLength}个地区`
        : this.firstCity;
    },
    placeholder() {
      if (this.optionInfo && this.optionInfo.placeholder) {
        return this.optionInfo.placeholder;
      }
      return '请选择所在地';
    },
    brief() {
      return `所在地为${this.allCity}`;
      // return `地域为${this.allCity}`;
    },
  },

  watch: {
    value(newValue) {
      let val = [];
      if (isArray(newValue)) {
        val = this.value;
      } else if (newValue && isArray(newValue.value)) {
        val = newValue.value;
      }
      this.currentValue = val;
    },
  },
  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      this.valid = !!(this.currentValue && this.currentValue.length > 0);
      return this.valid;
    },
    getAllLocations() {
      if (!window.__QIAIN_COM_LOCATIONS) {
        return [];
      }
      if (!this.Locations) {
        this.Locations = JSON.parse(JSON.stringify(window.__QIAIN_COM_LOCATIONS));
      }
      return this.Locations;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const selectArr = getRegionText(value, this.getAllLocations(), 'clientLib');
      const select = selectArr.map(item => ({ localCountry: item[0], localProvince: item[1], localCity: item[2] }));
      const ruleData = {
        operation: 'localAreaSelector',
        name: 'region',
        type: 'areaSelector',
        value: JSON.stringify(select),
      };
      const showVal = value;
      this.$nextTick(() => {
        this.$emit('change', {
          ruleData,
          showVal,
          brief: this.brief,
          validation: !!(select.length && select.length > 0),
        });
      });

      const inputArr = [];
      if (selectArr && selectArr.length > 0) {
        let provinceandCity = '';
        let province = '';

        selectArr.forEach((oriItem) => {
          const item = oriItem.slice();
          // 国外的标签只有两级，第二级为空, 第三级放在city中，
          if (item.length === 3 && item[1] === undefined) {
            item.splice(1, 1);
          }
          function pushCity() {
            if (provinceandCity !== '') {
              inputArr.push(provinceandCity);
            }
          }
          if (item.length < 3) {
            pushCity();
            inputArr.push(item[item.length - 1]);
            provinceandCity = '';
            province = '';
          } else if (item[1] !== province) {
            pushCity();
            // eslint-disable-next-line prefer-destructuring
            province = item[1];
            provinceandCity = `${item[1]}:${item[2]}`;
          } else {
            provinceandCity += `/${item[2]}`;
          }
        });
        if (provinceandCity !== '') {
          inputArr.push(provinceandCity);
        }
      }

      this.allCity = inputArr.join('，');
      console.log(this.allCity);
      setTimeout(() => {
        const isOverflow = this.$refs.wait;
        console.log(isOverflow);
        console.log(isOverflow.clientWidth);
        console.log(isOverflow.scrollWidth);
        if (isOverflow.clientWidth < isOverflow.scrollWidth - 2) {
          this.showWait = true;
        } else {
          this.showWait = false;
        }
      }, 0);
      // this.showWait = this.allCity.length > 57;
    },
    handleChangeValue(value) {
      this.citiesLength = value.length;
      this.firstCity = (value[0] || {}).name || '';
    },
    // 读取到地点信息后如果没有地区数据就重新加载一下
    handleRenderComplete() {
      if (!this.allCity) {
        this.onChange(this.currentValue);
      }
    },
    formatLabel(str, len) {
      let l = substring(str, len);
      if (l === str) {
        return str;
      }
      l = substring(str, len - 3);
      return `${l}...`;
    },
  },
};
</script>
<style lang="less">
.changeWidth {
    width: auto;
    max-width: 98%;
}

.region-label {
    position: relative;
    overflow: hidden;
    margin-right: 35px;
    padding-right: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
        position: absolute;
        right: -1px;
    }
}
</style>
